import CONFIG from './CONFIG.js';
import $ from 'jquery';
import {SESSION} from './authUtil.js';

let token = 'undefined';

function myAjax(url, data, type = 'POST', async = true, doNotFailMsg = false) {
  let serverUrl = CONFIG.SERVERURL;

  // トークン有効期限の確認
  if (!CONFIG.DISABLE_JWT) {
    getTokenAjax('/verify_token/', {token: token}, 'POST');
  }

  console.log('API: ' + url);

  let ajax_param = {
    url: serverUrl + url,
    type: type,
    cache: false,
    // contentType: "application/json",
    dataType: 'json',
    data: data,
    traditional: true,
    async: async
  };
  if (!CONFIG.DISABLE_JWT) {
    ajax_param.headers = {
      Authorization: CONFIG.JWT_AUTH_HEADER_PREFIX + ' ' + token
    };
  }

  if (SESSION.id) {
    ajax_param.headers = ajax_param.headers ? ajax_param.headers : {};
    ajax_param.headers['X-SessionID'] = SESSION.id;
  }

  let jqxhr = $.ajax(ajax_param);

  if (doNotFailMsg == false) {
    jqxhr.fail(function (jqXHR, textstatus, errThrown) {
      console.error(textstatus, errThrown.toString());
      alert(
        'ご迷惑をおかけして、大変申し訳ございません。 \nサーバへのアクセスが大変混み合っており、 ページを表示することができません。 '
      );
    });
  }

  jqxhr.done(function (data, textStatus, jqXHR) {
    let sid = jqXHR.getResponseHeader('X-SessionID');
    if (sid) {
      SESSION.id = sid;
    }
  });

  return jqxhr;
}

function myAjaxSync(url, data) {
  let serverUrl = CONFIG.SERVERURL;
  let headers = {};
  if (!CONFIG.DISABLE_JWT) {
    headers = {Authorization: CONFIG.JWT_AUTH_HEADER_PREFIX + ' ' + token};
  }
  if (SESSION.id) {
    headers = headers ? headers : {};
    headers['X-SessionID'] = SESSION.id;
  }
  return $.ajax({
    url: serverUrl + url,
    type: 'POST',
    headers: headers,
    cache: false,
    // contentType: "application/json",
    dataType: 'json',
    data: data,
    async: false, // wait until the request finished: for processing before closing the tab
    traditional: true
  });
}

let loggingUserQuestionAjax = (userQuestion, data) => {
  // Logging user question: data must be the return from /api/models/predict/

  let formatResult = (qa, idx) => {
    const score = ' (' + qa.score.toString().slice(0, 4) + ')';
    const question = qa.question;
    const index = idx + 1 + '. ';
    return index + question + score;
  };

  const predicted_result = data.slice(0, 5).map(formatResult).join('\n');
  const sendData = {
    user_question: userQuestion,
    predicted_result: predicted_result
  };

  return myAjax('/api/logging/core/', sendData);
};

// エンドサーバーからトークンを取得
let getTokenAjax = (url, data = 'None', type = 'GET') => {
  let serverUrl = CONFIG.AUTH_SERVERURL;
  console.log('API: ' + url);

  let jqxhr = $.ajax({
    url: serverUrl + url,
    async: false,
    type: type,
    cache: false,
    dataType: 'json',
    data: JSON.stringify(data),
    contentType: 'application/JSON',
    traditional: true
  })
    .done(function (data) {
      token = data['token'];
    })
    .fail(function (jqXHR) {
      // console.error(textstatus, errThrown.toString());
      switch (jqXHR.status) {
        case 400: // Bad Request
        case 401: {
          // Unauthorized
          let result = jqXHR.responseJSON['detail'][0];
          console.log(result);
          if (result === 'Signature has expired.') {
            // トークン有効期限切れ
            // トークンを再取得
            getTokenAjax('/get_token/');
            console.log('get new token!');
          } else if (result === 'Error decoding signature.') {
            // トークン形式NG（通常の接続では発生しない）
            console.error('エラーが発生しました。ステータス：' + jqXHR.status);
          }
          break;
        }
        default:
          console.error('エラーが発生しました。ステータス：' + jqXHR.status);
          break;
      }
    });
  return jqxhr;
};

export default myAjax;
export {myAjaxSync, loggingUserQuestionAjax, getTokenAjax};
